import ReactDOM from "react-dom"

import { SingleVoteCheckmark } from "./animationElements/Checkmark"
import Hearts from "./animationElements/Hearts"
import ThankYou from "./animationElements/ThankYou"
import { SingleVoteHeart } from "./animationElements/VotingHeart"
import { useAnimationContext } from "./AnimationContext"
import { OverlaidAnimationStyle } from "./types"

const Animation = () => {
  const {
    overlaidAnimation,
    setOverlaidAnimation,
    thankYouAnimationFirstName,
  } = useAnimationContext()

  if (!overlaidAnimation) {
    return null
  }

  const onComplete = () => {
    setOverlaidAnimation(null)
  }

  return ReactDOM.createPortal(
    <>
      {overlaidAnimation === OverlaidAnimationStyle.HEARTS && (
        <Hearts timeout={2000} onComplete={onComplete} />
      )}
      {overlaidAnimation === OverlaidAnimationStyle.HEART && (
        <SingleVoteHeart timeout={1000} onComplete={onComplete} />
      )}
      {overlaidAnimation === OverlaidAnimationStyle.CHECKMARK && (
        <SingleVoteCheckmark timeout={1000} onComplete={onComplete} />
      )}
      {overlaidAnimation === OverlaidAnimationStyle.THANKYOU && (
        <ThankYou
          onComplete={onComplete}
          name={thankYouAnimationFirstName}
        />
      )}
    </>,
    document.querySelector("#animation-target"),
  )
}

export default Animation
